// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedRgbChannelsColor_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill="#EF8354" d="M0 0H16V16H0z"/>
  <path d="M11.0508 11.7441C10.4375 12.041 9.63672 12.1895 8.64844 12.1895C7.35938 12.1895 6.3457 11.8105 5.60742 11.0527C4.86914 10.2949 4.5 9.28516 4.5 8.02344C4.5 6.67969 4.91406 5.58984 5.74219 4.75391C6.57422 3.91797 7.65234 3.5 8.97656 3.5C9.79688 3.5 10.4883 3.60352 11.0508 3.81055V5.63281C10.4883 5.29688 9.84766 5.12891 9.12891 5.12891C8.33984 5.12891 7.70312 5.37695 7.21875 5.87305C6.73438 6.36914 6.49219 7.04102 6.49219 7.88867C6.49219 8.70117 6.7207 9.34961 7.17773 9.83398C7.63477 10.3145 8.25 10.5547 9.02344 10.5547C9.76172 10.5547 10.4375 10.375 11.0508 10.0156V11.7441Z" class="svg-fg"/>
</svg>
`;
/**
 * IconMedRgbChannelsColor is a generated icon component.
 */
let IconMedRgbChannelsColor = IconMedRgbChannelsColor_1 = class IconMedRgbChannelsColor extends IconBaseElement {
    render() {
        return html `${IconMedRgbChannelsColor_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedRgbChannelsColor.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconMedRgbChannelsColor = IconMedRgbChannelsColor_1 = __decorate([
    customElement('zui-icon-med-rgb-channels-color')
], IconMedRgbChannelsColor);
export { IconMedRgbChannelsColor };
